import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { SKIP_GBE_ERROR_NOTIFICATION } from '@core/interceptors/gbe-error.interceptor';
import { GbeEndPointV4 } from '@core/models/gbe/gbe-endpoint.enum';
import {
  OptimizationLogsQuery,
  OptimizationLogsResponse
} from '@core/models/optimization-logs.model';
import { GBE_BASE_URL } from '@core/tokens/gbe-url.token';

/**
 * Client for the SUPER_USER-only optimization job logs endpoint. Returns the
 * pod's Cloud Logging entries for a given job (== DataLayerJob id). Errors are
 * handled inline by the viewer, so the global GBE notification is suppressed.
 *
 * Query params are written snake_case because they are not auto-converted by
 * the request interceptor (which only converts request bodies).
 */
@Injectable({ providedIn: 'root' })
export class OptimizationLogsService {
  private readonly http = inject(HttpClient);
  private readonly gbeUrl = inject(GBE_BASE_URL);

  private buildUrl(endpoint: string): string {
    return `${this.gbeUrl}/${endpoint}`;
  }

  fetchLogs$(
    optimizationId: string,
    query?: OptimizationLogsQuery
  ): Observable<OptimizationLogsResponse> {
    let params = new HttpParams().set('page_size', String(query?.pageSize ?? 200));
    if (query?.pageToken) {
      params = params.set('page_token', query.pageToken);
    }
    if (query?.endTime) {
      params = params.set('end_time', query.endTime);
    }

    return this.http.get<OptimizationLogsResponse>(
      this.buildUrl(`${GbeEndPointV4.OPTIMIZATIONS}/${optimizationId}/logs`),
      {
        params,
        context: new HttpContext().set(SKIP_GBE_ERROR_NOTIFICATION, true)
      }
    );
  }
}
